import type { MutableRefObject } from 'react';

import { useEffect } from 'react';

/**
 * Calls the callback function when clicked outside the element passed as ref.
 * @param {MutableRefObject<HTMLElement | null>} ref
 * @param {() => void} callback
 */
export function useOnClickOutside(
  ref: MutableRefObject<HTMLElement | null>,
  callback: () => void,
  ignoredElementName?: string,
  isOpen = true
) {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const listener = (event: MouseEvent) => {
      const clickedElement = event.target as HTMLElement;

      if (
        !ref.current ||
        ref.current.contains(clickedElement) ||
        clickedElement.getAttribute('name') === ignoredElementName
      ) {
        return;
      }

      callback();
    };

    document.addEventListener('mousedown', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [ref, callback, ignoredElementName, isOpen]);
}
